/*
 * @Author: Fan
 * @Date: 2020-04-16 19:44:30
 * @description:
 * @LastEditors: Fan
 */
import { DataType } from "../../../typings";
import { editableControlOptions } from ".";
import i18n from "../../../i18n";
export const inputControlOptions = {
    $id: "inputControlOptions",
    type: DataType.Object,
    $ref: editableControlOptions.$id,
    properties: {
        requiredFormula: {
            type: DataType.String,
            title: i18n.t('dataitem.RequiredFormula').toString(),
        },
        readonlyFormula: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.ReadonlyFormula').toString(),
            default: false,
        },
    },
};
